<template>
  <div
    :class="{
      veranstaltungen: true,
      fadeLoading: true,
      loading: dataStore.loading.veranstaltungen,
    }"
  >
    <Form v-if="view == 'standard'" />
    <ResultList v-if="view == 'standard'"/>
    <PreviewResultList v-if="view == 'preview'"/>
    
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useDataStore } from "@/store/";
import ResultList from "@/components/Veranstaltungen/ResultList";
import PreviewResultList from "@/components/Veranstaltungen/PreviewResultList";
import Form from "@/components/Veranstaltungen/Form";

const pluginTypeOut = (typeof pluginType === "undefined") ? "standard" : pluginType;

const dataStore = useDataStore();
const view= ref(pluginTypeOut);


</script>
